import {CatalogoApiService} from './../../service/api/catalogo.api';
import {MessageService} from 'primeng/components/common/messageservice';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {ModalService} from '../../service/modal.service';
import {FtaService} from '../../service/fta.service';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {ResultadoFiltroFta2, FTAFamily} from '../../model/filtros';
import {UtilApi} from '../../service/api/util.api';

@Component({
    selector: 'catalogo',
    templateUrl: './catalogo.component.html',
    styleUrls: ['./catalogo.component.css']
})

export class CatalogoComponent implements OnInit {

    constructor(
        private globalService: GlobalService,
        private catalogoService: CatalogoApiService,
        private router: Router,
        public modalService: ModalService,
        private ftaService: FtaService,
        private messageService: MessageService,
        public pesquisaService: PesquisasFiltroApiService,
        private utilApi: UtilApi
    ) {
    }

    msgs: any;
    temp = '';
    tempErro = '';

    //variaves do dashboard
    listaFTA1: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    listaFTA2: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    // listaFTA3: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    listaFTA3: Array<any> = [];

    listFtaFamily1: Array<FTAFamily> = new Array<FTAFamily>();
    listFtaFamily2: Array<FTAFamily> = new Array<FTAFamily>();
    listFtaFamily3: Array<FTAFamily> = new Array<FTAFamily>();

    loading1: boolean = true;
    loading2: boolean = true;
    loading3: boolean = true;

    isFtaAprovado: boolean = false;
    isFtaAtivado: boolean = false;

    mensagemVazio: string = 'Nenhum registro encontrado';

    paginaDash1: number = 1;
    paginaFinalDash1: number;

    paginaDash2: number = 1;
    paginaFinalDash2: number;

    paginaDash3: number = 1;
    paginaFinalDash3: number;

    private sub: any;

    ngOnInit() {
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, CatalogoComponent.prototype.carregarConstantes);

    }

    carregarConstantes() {
        this.temp = '';
        this.tempErro = '';
        this.globalService.loading = false;

        if (this.ftaService.msgFtaSalvo == 'sucesso') {
            this.temp = this.ftaService.numFtaSalvo.toString();
            //this.temp = this.ftaService.numFtaSalvo;
            /* this.modalService.exibirMensagem("Sucesso", "<p class='text-center'>FTA número <strong>" + fta + "</strong> salvo com sucesso <br /><br /><strong>Atenção:</strong> Este FTA se encontra pendente de despacho</p>", "Fechar"); */
            //this.msgs = this.mensagem.addMsgSucesso(`FTA número <strong>` + fta + `</strong> salvo com sucesso <br /><br /><strong>Atenção:</strong> Este FTA se encontra pendente de despacho</p>`);
        }

        if (this.ftaService.msgFtaSalvo == 'erro') {
            /* this.modalService.exibirMensagem("Erro", "Erro ao salvar FTA", "Fechar"); */
            //this.msgs = this.mensagem.addMsgError(`Erro ao salvar FTA`);
            this.tempErro = 'erro';
        }

        this.ftaService.msgFtaSalvo = '';
        this.ftaService.numFtaSalvo = 0;

        //aguardando despacho
        this.pesquisar(1, 1);

        //aguardando aprovação
        this.pesquisar(2, 1);

        //aguardando roteiro
        // this.pesquisar(3, 1);
        this.pesquisarRoteiro();

    }

    navegarPara(destino) {
        switch (destino) {
            case 'fluxoClienteInternoCompleto':
                this.router.navigate(['/fluxo-cliente-interno-completo']);
                break;
            case 'consultaFluxos':
                // this.router.navigate(['/consulta-fluxos']);
                this.router.navigate(['/pesquisa-fluxo']);
                break;
            case 'usuario':
                this.router.navigate(['/usuario']);
                break;
            case 'artefato-home':
                this.router.navigate(['/artefato-home']);
                break;
        }
    }

    alteraPagina(cotipoEstado, dashboard, tipo) {
        if (dashboard == 'despacha') {
            if (this.paginaDash1 >= 1) {
                if (tipo == 'avanca') {
                    if (this.paginaDash1 < this.paginaFinalDash1) {
                        this.paginaDash1 = this.paginaDash1 + 1;
                    }
                } else if (tipo == 'volta') {
                    if (this.paginaDash1 > 1) {
                        this.paginaDash1 = this.paginaDash1 - 1;
                    }
                } else if (tipo == 'primeira') {
                    this.paginaDash1 = 1;
                } else {
                    this.paginaDash1 = this.paginaFinalDash1;
                }
                this.pesquisar(cotipoEstado, this.paginaDash1);
            }
        }
        if (dashboard == 'aprova') {
            if (this.paginaDash2 >= 1) {
                if (tipo == 'avanca') {
                    if (this.paginaDash2 < this.paginaFinalDash2) {
                        this.paginaDash2 = this.paginaDash2 + 1;
                    }
                } else if (tipo == 'volta') {
                    if (this.paginaDash2 > 1) {
                        this.paginaDash2 = this.paginaDash2 - 1;
                    }
                } else if (tipo == 'primeira') {
                    this.paginaDash2 = 1;
                } else {
                    this.paginaDash2 = this.paginaFinalDash2;
                }
                this.pesquisar(cotipoEstado, this.paginaDash2);
            }
        }
        if (dashboard == 'roteiro') {
            if (this.paginaDash3 >= 1) {
                if (tipo == 'avanca') {
                    if (this.paginaDash3 < this.paginaFinalDash3) {
                        this.paginaDash3 = this.paginaDash3 + 1;
                    }
                } else if (tipo == 'volta') {
                    if (this.paginaDash3 > 1) {
                        this.paginaDash3 = this.paginaDash3 - 1;
                    }
                } else if (tipo == 'primeira') {
                    this.paginaDash3 = 1;
                } else {
                    this.paginaDash3 = this.paginaFinalDash3;
                }
                this.pesquisar(cotipoEstado, this.paginaDash3);
            }
        }
    }

    pesquisar(coTipoEstado, pagina) {
        let filtros = {
            'metadata': {
                'colunaOrdenacao': 'fta',
                'ordenacao': 'desc',
                'porPagina': 5,
                'pagina': pagina
            },
            'incluirTodasVersoesFTA': 'false',
            'filtros': [
                {
                    'filtroFta': {
                        'codTipoEstado': coTipoEstado,
                    },
                }
            ]
        };

        //this.globalService.loading = true;
        this.pesquisaService.mudarPagina(pagina);
        this.pesquisaService.filtraFtaDashboard(filtros)
            .subscribe(
                listaItens => {
                    //this.globalService.loading = false;
                    if (coTipoEstado == 1) {
                        this.loading1 = false;
                        this.listFtaFamily1 = this.ajustaFTAFamily(listaItens);
                        this.paginaFinalDash1 = listaItens.metadata.paginaTotal;

                    } else if (coTipoEstado == 2) {
                        this.loading2 = false;
                        this.listFtaFamily2 = this.ajustaFTAFamily(listaItens);
                        this.paginaFinalDash2 = listaItens.metadata.paginaTotal;
                    } else {
                        this.loading3 = false;
                        this.listFtaFamily3 = this.ajustaFTAFamily(listaItens);
                        this.paginaFinalDash3 = listaItens.metadata.paginaTotal;
                    }
                },
                erro => {
                    if (coTipoEstado == 1) {
                        this.loading1 = false;
                    } else if (coTipoEstado == 2) {
                        this.loading2 = false;
                    } else {
                        this.loading3 = false;
                    }
                    this.globalService.loading = false;
                }
            );
    }

    pesquisarRoteiro() {
        this.pesquisaService.filtraFtaRoteiro(null)
            .subscribe(
                listaItens => {
                    this.listaFTA3 = listaItens.roteirosPendentes;
                    this.loading3 = false;
                }, erro => {
                    this.loading3 = false;
                    this.listaFTA3 = [];
                });

    }

    ajustaFTAFamily(listaItens: ResultadoFiltroFta2): Array<FTAFamily> {
        let listFtaFamily: Array<FTAFamily> = new Array<FTAFamily>();
        listaItens.ftas.forEach((fta1, index) => {
            fta1.versoes.forEach(fta => {
                let ftaFamily: FTAFamily = new FTAFamily();
                ftaFamily.codFTA = fta1.fta.toString();
                if (fta.versao == 1) {
                    ftaFamily.codFTAPai = '';
                } else {
                    ftaFamily.codFTAPai = fta1.fta.toString();
                }
                ftaFamily.codModelo = fta.codModelo;
                ftaFamily.codTipoEstado = fta.codTipoEstado;
                ftaFamily.contratoIed = fta.contratoIed;
                ftaFamily.dataCriacao = fta.dataCriacao;
                ftaFamily.descricao = fta.descricao;
                ftaFamily.formatoIed = fta.formatoIed;
                ftaFamily.indicadorAtendimentoFiltros = fta.indicadorAtendimentoFiltros;
                ftaFamily.indicadorExclusao = fta.indicadorAtendimentoFiltros;
                ftaFamily.nome = fta.nome;
                ftaFamily.versao = fta.versao + '';
                listFtaFamily.push(ftaFamily);
            });
        });
        return listFtaFamily;
    }

    despacharFTA(codigoFTA: string, versaoFTA: string) {
        this.globalService.loading = true;
        this.catalogoService.despacharArtefatoFta(Number(codigoFTA), Number(versaoFTA), 'fta', 'FTA despachado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', resposta.mensagem, 'Fechar');
                    this.modalService.incluirDadosGerados('despachoOk');

                    this.listaFTA1 = new ResultadoFiltroFta2();
                    this.loading1 = true;
                    setTimeout(() => {
                        this.pesquisar(1, 1);
                    }, 1500);

                    this.listaFTA2 = new ResultadoFiltroFta2();
                    this.loading2 = true;
                    setTimeout(() => {
                        this.pesquisar(2, 1);
                    }, 2000);

                    this.listaFTA3 = [];
                    this.loading3 = true;
                    setTimeout(() => {
                        // this.pesquisar(3, 1)
                        this.pesquisarRoteiro();
                    }, 3000);

                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', `Ocorreu um erro ao despachar o FTA. ${erro.error.mensagem}`, 'Fechar');
                }
            );
    }

    aprovar(codigoFTA: number, versaoFTA: number) {
        this.aprovarFTA(codigoFTA, versaoFTA);
    }

    aprovarFTA(codigoFTA: number, versaoFTA: number) {
        this.catalogoService.aprovaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'FTA aprovado')
            .subscribe(resposta => {
                    // this.modalService.exibirMensagem("Sucesso", "Fluxo de Transmissão de Arquivo número <b>" + codigoFTA + "</b> aprovado com sucesso!", "Fechar");
                    //this.modalService.incluirDadosGerados("despachoOk");
                    this.ativarFTA(codigoFTA, versaoFTA);
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', `Ocorreu um erro ao aprovar o FTA. ${erro.error.mensagem}`, 'Fechar');
                }
            );
    }

    ativarFTA(codigoFTA: number, versaoFTA: number) {
        this.catalogoService.aprovaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'FTA despachado');
        this.catalogoService.ativaDesativaArtefatoFta(codigoFTA, versaoFTA, 'fta', 'ativa', 'FTA ativado')
            .subscribe(resposta => {
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + codigoFTA + '</b> aprovado e ativado com sucesso!', 'Fechar');
                    this.listaFTA2 = new ResultadoFiltroFta2();
                    // this.listaFTA3 = new ResultadoFiltroFta2();
                    this.listaFTA3 = [];
                    this.loading2 = true;
                    this.loading3 = true;
                    this.pesquisar(2, 1);
                    // this.pesquisar(3, 1);
                    this.pesquisarRoteiro();
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Erro', `Ocorreu um erro ao ativar o FTA. ${erro.error.mensagem}`, 'Fechar');
                }
            );
    }


    consultaRoteiro(fta: any) {
        this.pesquisaService.detalhaFtaRoteiro(fta.codFta, fta.vrsFta)
            .subscribe(
                rs => {
                    let resultado = rs as any;
                    let msgIteracao = '';
                    // resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro = 1;
                    if (resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro != null) {
                        msgIteracao = ' - Interação: ' + resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro;
                    }
                    this.modalService.abrirPaginaModal('roteiro-fta-modal', {}, {
                        'codFTA': fta.codFta,
                        'vrsFTA': fta.vrsFta
                    }, `Roteiro do FTA nr. ${fta.codFta} v. ${fta.vrsFta} ${msgIteracao}`, 'Fechar').subscribe(
                        produto => {
                            if (produto != null) {

                            }
                        });

                },
                erro => {
                    if (erro.status == 404) {
                    }
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/catalogo/catalogo.component.ts